(function () {
  function isChatOpen() {
    return (
      document.querySelector('iframe[src*="inbox"]') ||
      document.querySelector('iframe[title*="Shopify Inbox"]')
    );
  }

  function updateState() {
    if (isChatOpen()) {
      document.body.classList.add('chat-open');
    } else {
      document.body.classList.remove('chat-open');
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.id === 'chat-close-btn') {
      // Close chat by simulating ESC
      document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape' }));
      document.body.classList.remove('chat-open');
    }
  });

  setInterval(updateState, 500);
})();
